<template>
    <div class="user">
        <div class="banner">
            <div class="pancel">
                <img src="../../assets/img/user/avatar.png" class="avatar" alt=""/>
                <div class="pancel-info">
                    <dl class="pancel-info-item">
                        <dt>用户账号：</dt>
                        <dd class="text">{{userInfo.nick_name}}</dd>
                    </dl>
                    <dl class="pancel-info-item">
                        <dt>用户等级：</dt>
                        <dd class="level">{{userInfo.level}}</dd>
                    </dl>
                </div>
            </div>
            <div class="user-info">
                <div class="user-info-item" v-for="item in infoList" :key="item.text">
                    <dl class="icon">
                        <img :src="item.icon" alt=""/>
                    </dl>
                    <dl>
                        <dt>{{item.text}}</dt>
                        <dd>{{item.num}}</dd>
                    </dl>
                </div>
            </div>
        </div>
        <van-cell-group class="user-cell" :border="false">
            <van-cell
                    v-for="(item,index) in cellList"
                    :key="item.title"
                    :title="item.title"
                    :to="item.toUrl"
                    @click="cellClick(item)"
                    class="user-cell-item"
                    title-class="user-cell-title"
                    is-link>
                <div slot="icon" :class="'user-cell-img' + index">
                    <img :src="item.icon" alt=""/>
                </div>
            </van-cell>
        </van-cell-group>
        <Tabbar active="user"></Tabbar>
    </div>
</template>

<script>
    import Tabbar from "../../components/tabbar";
    import {mapState, mapMutations} from "vuex"

    export default {
        components: {
            Tabbar
        },
        data() {
            return {
                infoList: [],
                cellList: [
                    {
                        icon: require("../../assets/img/user/transfer.png"),
                        title: "用户转账",
                        toUrl: '/transfer'
                    },
                    {
                        icon: require("../../assets/img/user/cell_icon1.png"),
                        title: "实名认证",
                        toUrl: '/certification'
                    },
                    {
                        icon: require("../../assets/img/user/cell_icon2.png"),
                        title: "安全中心",
                        toUrl: '/safeCenter'
                    },
                    {
                        icon: require("../../assets/img/user/cell_icon3.png"),
                        title: "账户记录",
                        toUrl: '/accoundRecord'
                    },
                    {
                        icon: require("../../assets/img/user/cell_icon4.png"),
                        title: "公告",
                        toUrl: '/noticeList'
                    },
                    {
                        icon: require("../../assets/img/user/cell_icon5.png"),
                        title: "退出登录",
                        toUrl: '',
                    },
                ],
            };
        },
        computed: {
            ...mapState(['userInfo'])
        },
        created() {
            // this.getUserInfo();
            this.getUserInfoEvent();
        },
        methods: {
            // 获取用户信息
            ...mapMutations({
                setUserInfo: 'setUserInfo'
            }),
            getUserInfoEvent() {
                this.ajax.get('/appapi/user/getUserInfo').then((res) => {
                    if (res.data.code === 1) {
                        let data = res.data.data;
                        this.setUserInfo(data);
                        this.infoList = [
                            {
                                icon: require("../../assets/img/user/xmi.png"),
                                text: "XMI",
                                num: Number(data.xmi).toFixed(3)
                            },
                            {
                                icon: require("../../assets/img/user/usdt.png"),
                                text: "USDT",
                                num: Number(data.usdt).toFixed(3)
                            },
                            {
                                icon: require("../../assets/img/user/info_icon2.png"),
                                text: "奖金累计",
                                num: Number(data.bonus).toFixed(3)
                            },
                            {
                                icon: require("../../assets/img/user/info_icon3.png"),
                                text: "有效矿机",
                                num: Number(data.miner_num).toFixed(3)
                            },
                            {
                                icon: require("../../assets/img/user/info_icon4.png"),
                                text: "总收益",
                                num: Number(data.bonus).toFixed(3)
                            },
                            {
                                icon: require("../../assets/img/user/info_icon5.png"),
                                text: "个人算力",
                                num: Number(data.power).toFixed(3)
                            }
                        ];
                    }
                })
            },
            // cell 点击事件（单独处理退出登录）
            cellClick(item) {
                if (item.title === "退出登录") {
                    this.$dialog.confirm({
                        title: '退出登录',
                        message: '是否退出登录？'
                    }).then(() => {
                        this.ajax.post("appapi/user/logout", {}).then(res => {
                            if (res.data.code === 1) {
                                this.$toast(res.data.msg);
                                sessionStorage.clear();
                                this.$router.push({path: "/login"});
                            }
                        });
                    }).catch(() => {
                    });
                }
            }
        }
    };
</script>

<style lang="scss">
    .user {
        padding-bottom: 280px;

        .banner {
            position: relative;
            background: url(../../assets/img/background.png) no-repeat 0 0;
            background-size: 100%;
            width: 100%;
            padding: 120px 40px 0;
        }

        .pancel {
            margin-bottom: 50px;
            @include flex();

            .avatar {
                width: 114px;
                height: 114px;
                margin-right: 50px;
            }

            &-info {
                color: #badfcb;
                font-size: 24px;

                &-item {
                    @include flex();
                    color: #fff;
                    margin-bottom: 16px;

                    .text {
                        font-size: 30px;
                        font-weight: bold;
                    }

                    .level {
                        width: 126px;
                        height: 38px;
                        font-size: 20px;
                        line-height: 38px;
                        padding-left: 45px;
                        box-sizing: border-box;
                        background: url(../../assets/img/user/level.png) no-repeat center;
                        background-size: cover;
                    }
                }
            }
        }

        &-info {
            @include flex($wrap: wrap, $main: space-between);

            &-item {
                @include flex();
                width: 322px;
                height: 124px;
                background: rgba(255, 255, 255, 1);
                box-shadow: 0 10px 29px 0 rgba(226, 226, 226, 0.4);
                border-radius: 20px;
                box-sizing: border-box;
                padding: 27px 30px;
                color: #4f5668;
                font-weight: bold;
                margin-bottom: 15px;
                position: relative;

                .icon {
                    margin-right: 30px;
                    width: 60px;
                    padding: 10px 0;
                }

                dt {
                    font-size: 26px;
                    margin-bottom: 10px;
                }

                dd {
                    font-size: 40px;
                }

                .ping {
                    position: absolute;
                    top: 0;
                    right: 16px;
                    width: 45px;
                }
            }
        }

        &-cell {
            margin-top: 18px;

            &-item {
                padding: 30px 33px;
                align-items: center;
            }

            &-title {
                color: #333;
                font-size: 24px;
                margin-left: 25px;
            }

            &-img0 {
                width: 44px;
                height: 38px;
            }

            &-img1 {
                width: 42px;
                height: 31px;
            }

            &-img2 {
                width: 34px;
                height: 40px;
            }

            &-img3 {
                width: 35px;
                height: 45px;
            }

            &-img4, &-img5 {
                width: 40px;
            }
        }
    }
</style>
